import type { AlertProps } from '@/types/alert'

const useAlert = () => useState('alert', () => <AlertProps>({
	id: '',
	title: '',
	message: '',
	active: false,
	open: true,
	expanded: false,
	createdTime: new Date().toISOString(),
	updated: new Date().toISOString()
}))

export {
	useAlert
}
